// ABOUTME: Sticky primary-coloured action bar at the top of the object schema forms (product info, groups, content types).
// ABOUTME: Layout shell only: hosts the forms' action buttons, right-aligned; the product/group context lives in the breadcrumb below.

import { AppBar, Box, Stack } from '@ds/coolshop';
import { PropsWithChildren } from 'react';

export const ProductActionBar = ({ children }: PropsWithChildren) => (
    <Box
        position="sticky"
        top={0}
        zIndex={theme => theme.zIndex.drawer + 1}
        // Bleed into the FormElement gutters and the form's own inset so the bar spans the
        // full pane width.
        mx={{ xs: -5, sm: -6 }}
    >
        <AppBar color="primary">
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="flex-end"
                flexWrap="wrap"
                gap={1}
                width="100%"
            >
                {children}
            </Stack>
        </AppBar>
    </Box>
);
